import { DropdownPopover, Button, ArticleHeading4, Spinner, Outside } from '@cian/ui-kit';
import { ArrowDown16, Success16 } from '@cian/ui-kit/prev';
import * as React from 'react';

import * as styles from './TopMenuDesktop.css';
import { ERoute, TRoute } from '../../types/route';
import { ETopMenuStatus } from '../../types/topMenuStatus';

type TTopMenuDesktopProps = {
  currentRoute: TRoute;
  isChangeListVisible: boolean;
  selectedCount: number;
  onChangeRoute(route: TRoute): void;
  onChangeListClick(): void;
  status: ETopMenuStatus;
};

const MenuItems: { [key in ERoute]: string } = {
  [ERoute.Messages]: 'Все сообщения',
  [ERoute.Unread]: 'Непрочитанные',
  [ERoute.Spam]: 'Заблокированные',
  [ERoute.Archive]: 'Архив',
};

export const TopMenuDesktop: React.VFC<TTopMenuDesktopProps> = ({
  currentRoute,
  onChangeRoute,
  isChangeListVisible,
  onChangeListClick,
  selectedCount,
  status,
}) => {
  const [isOpen, setIsOpen] = React.useState(false);

  const popupContent = React.useMemo(
    () => (
      <Outside onOutside={() => setIsOpen(false)} active={isOpen} insideRefs={[]}>
        <ul className={styles['content']} data-testid="TopMenuDesktopList">
          {Object.entries(MenuItems).map(([key, value]) => (
            <li
              key={key}
              className={styles['item']}
              onClick={() => {
                setIsOpen(false);
                onChangeRoute(key as TRoute);
              }}
            >
              {value}
              {key === currentRoute && <Success16 color="primary_100" />}
            </li>
          ))}
        </ul>
      </Outside>
    ),
    [currentRoute, onChangeRoute, isOpen],
  );

  const leftView = React.useMemo(() => {
    switch (status) {
      case ETopMenuStatus.Offline:
        return (
          <span className={styles['heading']}>
            <ArticleHeading4>Ожидание сети</ArticleHeading4>
            <Spinner size={16} />
          </span>
        );
      case ETopMenuStatus.ChangeList:
        return (
          <span className={styles['heading']}>
            <ArticleHeading4>
              {selectedCount > 0 ? `Выбрано ${selectedCount}` : MenuItems[currentRoute]}
            </ArticleHeading4>
          </span>
        );
      case ETopMenuStatus.NotAuthorized:
        return (
          <span className={styles['heading']}>
            <ArticleHeading4>{MenuItems[ERoute.Messages]}</ArticleHeading4>
          </span>
        );

      case ETopMenuStatus.Loading:
      default:
        return (
          <div>
            <DropdownPopover open={isOpen} content={popupContent}>
              <Button
                theme="fill_white_primary"
                onClick={e => {
                  e.preventDefault();

                  setIsOpen(!isOpen);
                }}
                color="black100"
              >
                {
                  /* Это хак, но тянуть все вспомогательные стили кнопки дорого */
                  (
                    <span className={styles['button']}>
                      {MenuItems[currentRoute]}
                      {status === ETopMenuStatus.Loading ? <Spinner size={16} /> : <ArrowDown16 color="primary_100" />}
                    </span>
                  ) as unknown as React.ReactText
                }
              </Button>
            </DropdownPopover>
          </div>
        );
    }
  }, [status, currentRoute, selectedCount, isOpen, popupContent]);

  return (
    <div data-testid="TopMenuDesktopContainer" className={styles['container']}>
      {leftView}
      {isChangeListVisible && (
        <Button
          size="XS"
          theme="fill_white_primary"
          onClick={onChangeListClick}
          disabled={status === ETopMenuStatus.Loading}
        >
          {[ETopMenuStatus.ChangeList, ETopMenuStatus.Loading].includes(status) ? 'Готово' : 'Изменить'}
        </Button>
      )}
    </div>
  );
};
